import { Component, Inject, Input, OnInit } from '@angular/core';
import { CampaignManagerVoucherOfferModel, DATE_OPTIONS, DateOptions } from '@fgb/core';

@Component({
  selector: 'fgb-campaigns-v2-voucher-list-item',
  templateUrl: './campaigns-v2-voucher-list-item.component.html',
  styleUrls: ['./campaigns-v2-voucher-list-item.component.scss'],
})
export class CampaignsV2VoucherListItemComponent implements OnInit {
  @Input() campaignEntitlement: CampaignManagerVoucherOfferModel;
  isDateExpired: boolean = false;
  isVoucherDateExpired: boolean = false;

  constructor(@Inject(DATE_OPTIONS) public dateOption: DateOptions) {}

  ngOnInit(): void {
    if (new Date(this.campaignEntitlement.ExpiryDate) >= new Date()) {
      this.isDateExpired = false;
    } else {
      this.isDateExpired = true;
    }
    this.isVoucherDateExpired = !!this.campaignEntitlement.VoucherExpiryDate && new Date(this.campaignEntitlement.VoucherExpiryDate) < new Date();
  }
}
